import { namedLoosely, findByName, normal } from "../catalogue/findByName";

export const EVERYONE = "Everyone";
/** What people call everyone in the Organization. */
export const EVERYONE_WORDS =
  /^(everyone|everybody|every1|evry1|all|all (?:the )?(parents|families|users|members)|(the )?(whole )?school|parents|families)$/;

/** "my class", "our learners": whose they are, but no Circle named. */
export const YOURS = /^(?:my|our)\s+(?:class(?:room)?|learners|students|kids|children|parents|families|group|grade|kids'?\s+parents)[?!.\s]*$/i;

/** Who a Notice can go to: Everyone, a Circle, or one User. */
export type Recipient =
  | { kind: "everyone"; name: string }
  | { kind: "circle"; id: string; name: string }
  | { kind: "user"; id: string; name: string };

/** The recipients a name means: Everyone by any of its names (or the Organization's), otherwise by name. */
export function findRecipients(all: Recipient[], wanted: string, organizationName?: string) {
  const target = normal(wanted);
  // An emoji or punctuation alone names no one
  if (!target) return [];
  if (EVERYONE_WORDS.test(target) || (organizationName && target === normal(organizationName))) {
    return all.filter((r) => r.kind === "everyone");
  }
  const found = findByName(all, wanted, (r) => r.name);
  if (found.length > 0) return found;
  // "grade 4 parents", "the jumpstart class": the Circle, named with who's in it
  const bare = target.replace(WHO_IS_IN_IT, " ").replace(/\s+/g, " ").trim();
  if (!bare || EVERYONE_WORDS.test(bare)) return [];
  const byBareName = bare === target ? [] : findByName(all, bare, (r) => r.name).filter((r) => r.kind === "circle");
  if (byBareName.length > 0) return byBareName;
  // "my grade 4 class", "gr 4", "grade four": the Circle with those words in its name
  return namedLoosely(all, wanted, (r) => r.name).filter((r) => r.kind === "circle");
}

/** Words naming who's in a Circle rather than which one: "grade 4 parents", "the jumpstart class". */
const WHO_IS_IN_IT = /\b(?:parents|families|learners|students|kids|children|class|group|circle)\b/g;
